export type SongTab = {
  id: string;
  title: string;
  artist: string;
  difficulty: "Beginner" | "Intermediate" | "Advanced";
  chords: string[];
  tabs: string[];
  category: string;
  pdfUrl: string; // URL to PDF file
};

// Easy to add new songs - just add to this array
export const SONGS: SongTab[] = [
  {
    id: "1",
    title: "Gulabi Aankhein",
    artist: "Mohammed Rafi",
    difficulty: "Beginner",
    chords: [],
    category: "Classics",
    tabs: [
    ],
    pdfUrl: "pdfs/GULABI AANKHEIN - UKULELE SEEKHO.pdf",
  },
  {
    id: "2",
    title: "Happy Birthday",
    artist: "Mildred and Patty Hill",
    difficulty: "Beginner",
    chords: [],
    category: "Classics",
    tabs: [],
    pdfUrl: "pdfs/HAPPY BIRTHDAY - UKULELE SEEKHO.pdf",
  },
  {
    id: "3",
    title: "Janam Janam",
    artist: "Antara Mitra, Arijit Singh",
    difficulty: "Intermediate",
    chords: [],
    category: "Bollywood",
    tabs: [],
    pdfUrl: "pdfs/JANAM JANAM - UKULELE SEEKHO.pdf",
  },
  {
    id: "4",
    title: "Jingle Bells",
    artist: "Ludwig van Beethoven",
    difficulty: "Beginner",
    chords: [],
    category: "Classics",
    tabs: [],
    pdfUrl: "pdfs/JINGLE BELL - UKULELE SEEKHO.pdf",
  },
  {
    id: "5",
    title: "Shape of you",
    artist: "Ed Sheeran",
    difficulty: "Intermediate",
    chords: [],
    category: "Pop",
    tabs: [],
    pdfUrl: "pdfs/SHAPE OF YOU - UKULELE SEEKHO.pdf",
  },
  {
    id: "6",
    title: "Faasle",
    artist: "Aditya Rikhari",
    difficulty: "Beginner",
    chords: [],
    category: "Bollywood",
    tabs: [],
    pdfUrl: "pdfs/FAASLE - UKULELE SEEKHO.pdf",
  },
  {
    id: "7",
    title: "Oru Maalai",
    artist: "Karthik",
    difficulty: "Beginner",
    chords: [],
    category: "Tamil",
    tabs: [],
    pdfUrl: "pdfs/ORI MAALAI - UKULELE SEEKHO.pdf",
  },
  {
    id: "8",
    title: "Raja Raja",
    artist: "Chozhan",
    difficulty: "Beginner",
    chords: [],
    category: "Tamil",
    tabs: [],
    pdfUrl: "pdfs/RAJA RAJA - UKULELE SEEKHO.pdf",
  },
  {
    id: "9",
    title: "Risk It All",
    artist: "Bruno Mars",
    difficulty: "Beginner",
    chords: [],
    category: "Pop",
    tabs: [],
    pdfUrl: "pdfs/RISK IT ALL - UKULELE SEEKHO.pdf",
  },
  {
    id: "10",
    title: "Saahiba",
    artist: "Aditya Rikhari",
    difficulty: "Beginner",
    chords: [],
    category: "Bollywood",
    tabs: [],
    pdfUrl: "pdfs/SAAHIBA - UKULELE SEEKHO.pdf",
  },
  {
    id: "11",
    title: "Sitaare",
    artist: "Farhan Akhtar, Shefali Alvares",
    difficulty: "Beginner",
    chords: [],
    category: "Bollywood",
    tabs: [],
    pdfUrl: "pdfs/SITAARE - UKULELE SEEKHO.pdf",
  },
];

